import React, { ReactNode } from "react";
import { SelectField } from "components/form";
import { FieldValues, Path, Control } from "react-hook-form";
import {
  LENDER_WATERFALL_FACT_NAMES_NUMERIC,
  LENDER_WATERFALL_FACT_NAMES_STRING,
} from "@trnsact/types-lender-waterfall";
import { determineRuleType } from "../lib";
import { booleanOptions } from "../constants";
import { ConditionsFieldsTypes } from "../types";
import { StringFieldsByRule } from "./StringFieldsByRule";
import { NumberFieldsByRule } from "./NumberFieldsByRule";

interface Props<FormValues extends FieldValues = FieldValues> {
  ruleType: string;
  name: Path<FormValues>;
  control: Control<FormValues>;
}

export const ConditionsFieldsByRuleTypeRHF = <FormValues extends FieldValues = FieldValues>({
  name,
  control,
  ruleType,
}: Props<FormValues>) => {
  const type = determineRuleType(ruleType as any);

  const renderFields: Record<ConditionsFieldsTypes, ReactNode> = {
    [ConditionsFieldsTypes.Boolean]: (
      <SelectField
        label="Select"
        control={control}
        variant="outlined"
        options={booleanOptions}
        name={`${name}.boolean.value` as Path<FormValues>}
      />
    ),
    [ConditionsFieldsTypes.Number]: (
      <NumberFieldsByRule control={control} type={ruleType as LENDER_WATERFALL_FACT_NAMES_NUMERIC} namePrefix={name} />
    ),
    [ConditionsFieldsTypes.String]: (
      <StringFieldsByRule control={control} type={ruleType as LENDER_WATERFALL_FACT_NAMES_STRING} name={name} />
    ),
  };

  return <>{renderFields[type]}</>;
};
